export const SET_CONTENT_GATES = "SET_CONTENT_GATES";
export const setContentGates = content => ({
    type: SET_CONTENT_GATES,
    payload: content
});